import * as contractCrud from "../../crud/contracts.crud";
import * as contractUserCrud from "../../crud/contractUser.crud";
import * as contractOtherPriceCrud from "../../crud/contractOtherPrice.crud";
import * as activityCrud from "../../crud/activity.crud";
import * as dashboardCrud from "../../crud/dashboard.crud";
import * as userCrud from "../../crud/user.crud";
import * as alertCrud from "../../crud/alert.crud";
import * as assetCrud from "../../crud/asset.crud";
import * as actionCrud from "../../crud/action.crud";
import * as authDuck from "./auth.duck";
import * as preferencesDuck from "./preferences.duck";
import Common from '../../shared/common';
import store from "../store";
import { select, put, takeLatest, all, call, } from "redux-saga/effects";
import { adjustContractTemplate } from "../../Templates/TemplateAdjust";
import TemplateHelper from "../../Templates/TemplateHelper";
// import DefaultTemplates from "../../Templates/DefaultTemplates";
import MenuItemsHelper from "../helpers/MenuItemsHelper";
import { propertySummary, actionCodeReducerToCount } from "../helpers/DashboardHelper";
import SystemHelper from "../../shared/systemHelper";
import { contractUserPartyOptionMapID } from "../../shared/lookup";
import { typeOptions as pendingActionTypes } from "../../pages/admin/Contracts/Contract/ContractActions";
import { addMonths } from 'date-fns';


const getContract = (store) => store.contract;
const getPreferences = (store) => store.preferences;
const getAuth = (store) => store.auth;
const getLang = (store) => store.i18n;


export const actionTypes = {
  CONTRACT_SET_PENDING: "[CONTRACT_SET_PENDING]",
  CONTRACT_LOAD_START: "[CONTRACT_LOAD_START]",
  CONTRACT_SET_CONTRACT: "[CONTRACT_SET_CONTRACT]",
  CONTRACT_SET_REFRESH: "[CONTRACT_SET_REFRESH]",
  CONTRACT_SET_USERS: "[CONTRACT_SET_USERS]",
  CONTRACT_SET_USER: "[CONTRACT_SET_USER]",
  // CONTRACT_SET_PICTURE: "[CONTRACT_SET_PICTURE]",
  // CONTRACT_REFRESH_SECONDARY_DATES: "[CONTRACT_REFRESH_SECONDARY_DATES]",
  // CONTRACT_SET_KEY_AND_COMPLETION_DATES: "[CONTRACT_SET_KEY_AND_COMPLETION_DATES]",
  CONTRACT_SET_DASHBOARD_AND_MENU: "[CONTRACT_SET_DASHBOARD_AND_MENU]",
  CONTRACT_SET_MENU_ITEMS: "[CONTRACT_SET_MENU_ITEMS]",
  CONTRACT_SET_FILTERED_ACTIONS: "[CONTRACT_SET_FILTERED_ACTIONS]",
  CONTRACT_REFRESH_DASHBOARD: "[CONTRACT_REFRESH_DASHBOARD]",
  CONTRACT_REFRESH_CONTRACT: "[CONTRACT_REFRESH_CONTRACT]",
  CONTRACT_REFRESH_USERS: "[CONTRACT_REFRESH_USERS]",
  CONTRACT_SET_DASHBOARD_CURRENCY: "[CONTRACT_SET_DASHBOARD_CURRENCY]",

  CONTRACT_FETCH_ACTIVITIES: "[CONTRACT_FETCH_ACTIVITIES]",
  CONTRACT_SET_ACTIVITIES: "[CONTRACT_SET_ACTIVITIES]",

  CONTRACT_FETCH_PAYMENT_RETENTION_LIST: "[CONTRACT_FETCH_PAYMENT_RETENTION_LIST]",
  CONTRACT_SET_PAYMENT_RETENTION_LIST: "[CONTRACT_SET_PAYMENT_RETENTION_LIST]",

  CONTRACT_FETCH_QUOTATION_ACTIVITIES_LIST: "[CONTRACT_FETCH_QUOTATION_ACTIVITIES_LIST]",
  CONTRACT_SET_QUOTATION_ACTIVITIES_LIST: "[CONTRACT_SET_QUOTATION_ACTIVITIES_LIST]",

  CONTRACT_SET_COMPANY_LOGO: "[CONTRACT_SET_COMPANY_LOGO]",

  CONTRACT_SET_TEMPLATE: "[CONTRACT_SET_TEMPLATE]",
  CONTRACT_LOGOUT: "[CONTRACT_LOGOUT] ",

  CONTRACT_SET_REFERENCE: "[CONTRACT_SET_REFERENCE]",
  CONTRACT_SET_SECOND_LEVEL_REFERENCE: "[CONTRACT_SET_SECOND_LEVEL_REFERENCE]",

  CONTRACT_REFRESH_ASSETS: "[CONTRACT_REFRESH_ASSETS]",
  CONTRACT_SET_ASSETS: "[CONTRACT_SET_ASSETS]",
};

const initialContractState = {
  contractid: null,
  contract: null,
  users: null,
  user: null,
  // picture: null,
  // companyLogos: {},
  // secondaryDates: null,
  activities: null,
  // poNumber: null,
  // sopCode: null,
  // price: null,
  // notifications: null,
  dashboard: null,
  template: null,
  lastLoadedEpochTime: null,
  pendingFetch: false,
  menuItems: null,
  quickMenuItems: null,
  manualActions: null,
  filteredManualActions: null,
  reference: null,
  secondReference: null,
  customFields: null,
  communicationTags: null,
  assets: null,
  dashboardCurrencyCode: null,
  pendingDrafts: null
};

export const reducer = (
  state = JSON.parse(JSON.stringify(initialContractState)),
  action
) => {
  switch (action.type) {
    case actionTypes.CONTRACT_SET_PENDING: {
      return {
        ...state,
        pendingFetch: true,
        contractid: action.payload.contractid,
      };
    }
    case actionTypes.CONTRACT_LOAD_START: {
      if (
        state.contract &&
        state.contract.contractid === Number(action.payload.contractid) &&
        action.payload.forceBlank !== true
      ) {
        return {
          ...state,
          pendingFetch: false,
          contractid: action.payload.contractid,
          lastLoadedEpochTime: new Date().getTime(),
        };
      } else {
        const emptyState = JSON.parse(JSON.stringify(initialContractState));
        return {
          ...emptyState,
          pendingFetch: false,
          contractid: action.payload.contractid,
          lastLoadedEpochTime: new Date().getTime(),
        };
      }
    }
    case actionTypes.CONTRACT_SET_CONTRACT: {
      return {
        ...state,
        contract: action.payload.contract,
        customFields: action.payload.customFields,
        communicationTags: action.payload.communicationTags,
        dashboardCurrencyCode: action.payload.dashboardCurrencyCode,
      };
    }
    case actionTypes.CONTRACT_SET_REFRESH: {
      return {
        ...state,
        contract: action.payload.contract,
        customFields: action.payload.customFields,
        communicationTags: action.payload.communicationTags,
        dashboardCurrencyCode: action.payload.dashboardCurrencyCode,
        pendingFetch: false,
        lastLoadedEpochTime: new Date().getTime(),
      };
    }
    case actionTypes.CONTRACT_SET_USERS: {
      return { ...state, users: action.payload.users };
    }
    case actionTypes.CONTRACT_SET_USER: {
      return { ...state, user: action.payload.user };
    }
    case actionTypes.CONTRACT_SET_DASHBOARD_CURRENCY: {
      return { ...state, dashboardCurrencyCode: action.payload.dashboardCurrencyCode };
    }
    // case actionTypes.CONTRACT_SET_PICTURE: {
    //   return { ...state, picture: action.payload.picture };
    // }
    // case actionTypes.CONTRACT_SET_KEY_AND_COMPLETION_DATES: {
    //   return { ...state, secondaryDates: action.payload.secondaryDates };
    // }
    case actionTypes.CONTRACT_SET_ASSETS: {
      return { ...state, assets: action.payload.assets };
    }

    case actionTypes.CONTRACT_SET_ACTIVITIES: {
      return {
        ...state,
        activities: action.payload.activities,
        pendingFetch: false,
      };
    }

    // case actionTypes.CONTRACT_SET_COMPANY_LOGO: {
    //   return {
    //     ...state,
    //     companyLogos: {
    //       ...state.companyLogos,
    //       [action.payload.id]: action.payload.data,
    //     },
    //   };
    // }

    case actionTypes.CONTRACT_SET_TEMPLATE: {
      return { ...state, template: action.payload.template };
    }

    case actionTypes.CONTRACT_SET_DASHBOARD_AND_MENU: {
      return {
        ...state,
        dashboard: action.payload.dashboard,
        manualActions: action.payload.manualActions,
        menuItems: action.payload.menuItems,
        quickMenuItems: action.payload.quickMenuItems,
        dashboardCurrencyCode: action.payload.dashboardCurrencyCode,
        pendingDrafts: action.payload.pendingDrafts
      };
    }
    case actionTypes.CONTRACT_SET_MENU_ITEMS: {
      return {
        ...state,
        menuItems: action.payload.menuItems,
      };
    }
    case actionTypes.CONTRACT_SET_FILTERED_ACTIONS: {
      return {
        ...state,
        filteredManualActions: action.payload.filteredManualActions
      };
    }
    case actionTypes.CONTRACT_LOGOUT: {
      return initialContractState;
    }
    case actionTypes.CONTRACT_SET_REFERENCE: {
      return { ...state, reference: action.payload.reference };
    }
    case actionTypes.CONTRACT_SET_SECOND_LEVEL_REFERENCE: {
      return { ...state, secondReference: action.payload.reference };
    }
    default:
      return state;
  }
};
export const scheduledTasks = () => {
  const authStore = store.getState().auth;
  const contractStore = store.getState().contract;
  if (authStore && contractStore) {
    if (authStore.authToken.token && authStore.csrfToken.token) {
      if (contractStore.lastLoadedEpochTime && contractStore.contractid) {
        const refreshIntervalSec = Number(
          process.env.REACT_APP_CONTRACT_CLOCK_INTERVAL
        );
        //CONTRACT WILL RELOAD IF LOADED BEFORE $refreshIntervalSec SECONDS
        if (
          new Date(
            contractStore.lastLoadedEpochTime + refreshIntervalSec * 1000
          ) < new Date()
        ) {
          store.dispatch(actions.refreshContract());
          store.dispatch(actions.refreshDashboard());
        }
      }
    }
  }
};
export const actions = {
  fetchStart: (contractid, forceBlank) => {
    const authStore = store.getState().auth;
    const contractStore = store.getState().contract;

    if (authStore) {
      if (!authStore.authToken.token || !authStore.csrfToken.token) {
        if (!contractStore.pendingFetch) {
          return {
            type: actionTypes.CONTRACT_SET_PENDING,
            payload: { contractid },
          };
        }
        return { type: "" };
      }
    }

    return {
      type: actionTypes.CONTRACT_LOAD_START,
      payload: { contractid, forceBlank },
    };
  },

  setContract: (contract, customFields, communicationTags, dashboardCurrencyCode) => ({
    type: actionTypes.CONTRACT_SET_CONTRACT,
    payload: { contract, customFields, communicationTags, dashboardCurrencyCode },
  }),
  setContractRefresh: (contract, customFields, communicationTags, dashboardCurrencyCode) => ({
    type: actionTypes.CONTRACT_SET_REFRESH,
    payload: { contract, customFields, communicationTags, dashboardCurrencyCode },
  }),
  setUsers: (users) => ({
    type: actionTypes.CONTRACT_SET_USERS,
    payload: { users },
  }),
  setUser: (user) => ({
    type: actionTypes.CONTRACT_SET_USER,
    payload: { user },
  }),

  // setPicture: (picture) => ({
  //   type: actionTypes.CONTRACT_SET_PICTURE,
  //   payload: { picture },
  // }),
  // setKeyAndCompletionDates: (secondaryDates) => ({
  //   type: actionTypes.CONTRACT_SET_KEY_AND_COMPLETION_DATES,
  //   payload: { secondaryDates },
  // }),
  setAssets: (assets) => ({
    type: actionTypes.CONTRACT_SET_ASSETS,
    payload: { assets },
  }),

  refreshDashboard: () => ({ type: actionTypes.CONTRACT_REFRESH_DASHBOARD }),
  refreshUsers: () => ({ type: actionTypes.CONTRACT_REFRESH_USERS }),
  refreshContract: () => ({ type: actionTypes.CONTRACT_REFRESH_CONTRACT }),
  setDashboardCurrency: (dashboardCurrencyCode) => ({
    type: actionTypes.CONTRACT_SET_DASHBOARD_CURRENCY,
    payload: { dashboardCurrencyCode },
  }),



  fetchActivities: () => {
    return { type: actionTypes.CONTRACT_FETCH_ACTIVITIES };
  },
  setActivities: (activities) => ({
    type: actionTypes.CONTRACT_SET_ACTIVITIES,
    payload: { activities },
  }),

  // setCompanyLogo: (id, data) => ({
  //   type: actionTypes.CONTRACT_SET_COMPANY_LOGO,
  //   payload: { id, data },
  // }),


  setTemplate: (template) => ({
    type: actionTypes.CONTRACT_SET_TEMPLATE,
    payload: { template },
  }),

  setDashboardAndMenu: (dashboard, manualActions, menuItems, quickMenuItems, dashboardCurrencyCode, pendingDrafts) => ({
    type: actionTypes.CONTRACT_SET_DASHBOARD_AND_MENU,
    payload: { dashboard, manualActions, menuItems, quickMenuItems, dashboardCurrencyCode, pendingDrafts },
  }),
  setMenuItems: (menuItems) => ({
    type: actionTypes.CONTRACT_SET_MENU_ITEMS,
    payload: { menuItems },
  }),
  setFilteredActions: (filteredManualActions) => ({
    type: actionTypes.CONTRACT_SET_FILTERED_ACTIONS,
    payload: { filteredManualActions },
  }),
  logout: () => ({ type: actionTypes.CONTRACT_LOGOUT }),
  setReference: (reference) => ({
    type: actionTypes.CONTRACT_SET_REFERENCE,
    payload: { reference },
  }),
  setSecondReference: (reference) => ({
    type: actionTypes.CONTRACT_SET_SECOND_LEVEL_REFERENCE,
    payload: { reference },
  }),
};



export const getLocalUser = (accountid, userList, optionalName) => {
  return new Promise((resolve, reject) => {
    try {
      const globalStore = store.getState();
      const localList = userList ? userList : globalStore.contract.users;


      if (localList) {
        const localUser = localList.find((user) => user.userid === accountid);
        if (localUser) {
          resolve(localUser);
          return;
        }
      }
      userCrud
        .getUser(accountid)
        .then((resp) => {

          if (resp.data) {
            const systemUser = resp.data;
            //convert to an object like "Contract User"
            resolve({
              userid: systemUser.accountid,
              user: systemUser.name,
              usercompany: systemUser.company,

            });
            return;
          } else {
            reject(`AccountID:${accountid} user not found!`);
          }
        })
        .catch((err) => {
          if (optionalName) {
            resolve({
              userid: accountid,
              user: optionalName,
              // companyname: 'Unknown'
            });
          }
          else {
            resolve({
              userid: 1,
              user: "Administrator",
              // companyname: 'Unknown'
            });
          }
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const getAssets = (forceRefresh, status) => {
  return new Promise(async (resolve, reject) => {
    try {
      const globalStore = store.getState();
      const localAssets = globalStore.contract.assets;
      if (localAssets && forceRefresh !== true) {
        if (status === 'ACTIVE') {
          const activeLocalAssets = localAssets.filter(a => a.IsActive === true);
          resolve(activeLocalAssets);
          return;
        }
        else {
          resolve(localAssets);
          return;
        }

      }
      else {
        if (globalStore.contract.contract) {
          const { data: assets } = await assetCrud.getRegisterList(
            globalStore.contract.contract.contractid
          );
          if (assets) {
            await store.dispatch({ type: actionTypes.CONTRACT_SET_ASSETS, payload: { assets: assets } });
            if (status === 'ACTIVE') {
              const activeAssets = assets.filter(a => a.IsActive === true);
              resolve(activeAssets);
              return;
            }
            else {
              resolve(assets);
              return;
            }
          }

        }
      }
    } catch (error) {
      reject(error);
    }
  });
}

export function* saga() {
  yield takeLatest(
    authDuck.actionTypes.AUTH_LOAD_COMPLETED,
    function* contractLoginSaga() {
      try {
        let contractStore = yield select(getContract);
        if (contractStore.pendingFetch) {
          yield put(actions.fetchStart(contractStore.contractid));
        }
      } catch (err) {
        console.log("Error in contractLoginSaga:", err);
      }
    }
  );
  yield takeLatest([actionTypes.CONTRACT_LOAD_START, actionTypes.CONTRACT_REFRESH_CONTRACT], function* contractLoadContractSaga(sagaArgs) {
    try {
      let contractStore = yield select(getContract);


      const { data: contractDetails } = yield contractCrud.getContract(contractStore.contractid);



      if (contractDetails.scope) {
        try {
          contractDetails.scope = Number(contractDetails.scope);
        } catch (error) { console.log('Unable to convert contract scope proberty to Number', contractDetails.scope) }
      }
      if (contractDetails.tags && contractDetails.tags.categories) {
        contractDetails.tags.categories.forEach(tagCategory => {
          switch (tagCategory.name) {
            case 'Areas':
              contractDetails.areaids = tagCategory.tags.map(tag => tag.tagid);
              break;
            case 'Hubs':
              contractDetails.hubids = tagCategory.tags.map(tag => tag.tagid);
              break;
            case 'Frameworks':
              contractDetails.frameworkids = tagCategory.tags.map(tag => tag.tagid);
              break;
            case 'Lots':
              contractDetails.lotids = tagCategory.tags.map(tag => tag.tagid);
              break;
            case 'ContractOther':
              contractDetails.othercontracttagids = tagCategory.tags.map(tag => tag.tagid);
              break;
            case 'SecurityGroups':
              contractDetails.securitygroupids = tagCategory.tags.map(tag => tag.tagid);
              break;
            default:
              break;
          }
        });
      }


      let reducedCustomFields = {};
      if (contractDetails.workflowcustomfields) {
        reducedCustomFields = Common.GroupBy(contractDetails.workflowcustomfields, 'workflowid');
        for (let workflowid in reducedCustomFields) {
          reducedCustomFields[workflowid] = Common.GroupBy(reducedCustomFields[workflowid], 'subtype');
        }
      }
      contractDetails.designatedUsers = {};
      contractDetails.designatedUsers.pm = { user: contractDetails.projectmanager, userid: contractDetails.projectmanagerid, usercompany: contractDetails.userpmcompanyname, company: contractDetails.pmcompanyname };
      contractDetails.designatedUsers.supplier = { user: contractDetails.contractmanager, userid: contractDetails.contractmanagerid, usercompany: contractDetails.usercontractcompanyname, company: contractDetails.contractorcompanyname };
      contractDetails.designatedUsers.supervisor = { user: contractDetails.supervisor, userid: contractDetails.supervisorid, usercompany: contractDetails.usersupervisorcompanyname, company: contractDetails.supervisorcompanyname };
      contractDetails.designatedUsers.employer = { user: contractDetails.employer, userid: contractDetails.employerid, usercompany: contractDetails.useremployercompanyname, company: contractDetails.employercompanyname };

      // contractDetails.features = {}
      // // contractDetails.features.ACTIONS_ENABLED = Common.IsActionEnabled(contractDetails.companyid);
      // contractDetails.features.GENERIC_DRAFTS_ENABLED = Common.IsGenericDraftsEnabled(contractDetails.companyid);

      if (sagaArgs.type === actionTypes.CONTRACT_LOAD_START) {
        yield put(actions.setContract(contractDetails, reducedCustomFields, contractDetails.specifictags, contractDetails.currency));
      }
      else if (sagaArgs.type === actionTypes.CONTRACT_REFRESH_CONTRACT) {
        yield put(actions.setContractRefresh(contractDetails, reducedCustomFields, contractDetails.specifictags, contractDetails.currency));
      }

    } catch (err) {
      console.log("Error in contractLoadContractSaga:", err);
    }
  }
  );
  // yield takeLatest(actionTypes.CONTRACT_REFRESH_CONTRACT, function* contractRefreshContractSaga() {
  //   try {
  //     let contractStore = yield select(getContract);
  //     const { data: contractDetails } = yield contractCrud.getContract(
  //       contractStore.contractid
  //     );
  //     if (contractDetails.scope) {
  //       try {
  //         contractDetails.scope = Number(contractDetails.scope);
  //       } catch (error) { console.log('Unable to convert contract scope proberty to Number', contractDetails.scope) }
  //     }
  //     if (contractDetails.tags && contractDetails.tags.categories) {
  //       contractDetails.tags.categories.forEach(tagCategory => {
  //         switch (tagCategory.name) {
  //           case 'Areas':
  //             contractDetails.areaids = tagCategory.tags.map(tag => tag.tagid);
  //             break;
  //           case 'Hubs':
  //             contractDetails.hubids = tagCategory.tags.map(tag => tag.tagid);
  //             break;
  //           case 'Frameworks':
  //             contractDetails.frameworkids = tagCategory.tags.map(tag => tag.tagid);
  //             break;
  //           case 'Lots':
  //             contractDetails.lotids = tagCategory.tags.map(tag => tag.tagid);
  //             break;
  //           case 'ContractOther':
  //             contractDetails.othercontracttagids = tagCategory.tags.map(tag => tag.tagid);
  //             break;
  //           default:
  //             break;
  //         }
  //       });
  //     }


  //     let reducedCustomFields = {};
  //     if (contractDetails.workflowcustomfields) {
  //       reducedCustomFields = Common.GroupBy(contractDetails.workflowcustomfields, 'workflowid');
  //       for (let workflowid in reducedCustomFields) {
  //         reducedCustomFields[workflowid] = Common.GroupBy(reducedCustomFields[workflowid], 'subtype');
  //       }
  //     }
  //     contractDetails.designatedUsers = {};
  //     contractDetails.designatedUsers.pm = { user: contractDetails.projectmanager, userid: contractDetails.projectmanagerid, usercompany: contractDetails.userpmcompanyname, company: contractDetails.pmcompanyname };
  //     contractDetails.designatedUsers.supplier = { user: contractDetails.contractmanager, userid: contractDetails.contractmanagerid, usercompany: contractDetails.usercontractcompanyname, company: contractDetails.contractorcompanyname };
  //     contractDetails.designatedUsers.supervisor = { user: contractDetails.supervisor, userid: contractDetails.supervisorid, usercompany: contractDetails.usersupervisorcompanyname, company: contractDetails.supervisorcompanyname };
  //     contractDetails.designatedUsers.employer = { user: contractDetails.employer, userid: contractDetails.employerid, usercompany: contractDetails.useremployercompanyname, company: contractDetails.employercompanyname };

  //     yield put(actions.setContractRefresh(contractDetails, reducedCustomFields, contractDetails.specifictags));
  //   } catch (err) {
  //     console.log("Error in contractRefreshContractSaga:", err);
  //   }
  // }
  // );
  // yield takeLatest(
  //   actionTypes.CONTRACT_LOAD_START,
  //   function* contractLoadPictureSaga() {
  //     try {
  //       let contractStore = yield select(getContract);
  //       const { data: contractPicture } = yield contractCrud.getContractPicture(
  //         contractStore.contractid
  //       );
  //       yield put(actions.setPicture(contractPicture));
  //     } catch {
  //       // console.log('contract picture coulnt be retrieved');
  //       yield put(
  //         actions.setPicture(toAbsoluteUrl("/media/logos/default.png"))
  //       );
  //     }
  //   }
  // );
  yield takeLatest(actionTypes.CONTRACT_SET_USER, function* contractLoadTemplateSaga() {
    try {
      let contractStore = yield select(getContract);
      let langStore = yield select(getLang);
      let authStore = yield select(getAuth);

      if (contractStore.user && contractStore.contract) {
        let contractTemplate = null;
        if (contractStore.contract.templatejson && contractStore.contract.templatejson.length > 0) {
          contractTemplate = TemplateHelper.templateSanitizer(JSON.parse(contractStore.contract.templatejson), contractStore.contract);
          contractTemplate = adjustContractTemplate(contractStore.contract, contractTemplate, contractStore.user, authStore.userProfile);

          yield put(actions.setTemplate(contractTemplate));
        } else {
          console.log(
            "contract template not found, default template will be loaded for this contract!"
          );
          alert("contract template not found, default template will be loaded for this contract!");
          // contractTemplate = adjustContractTemplate(
          //   JSON.parse(JSON.stringify(DefaultTemplates[0])),
          //   contractStore.user, contractStore.contract, langStore.lang
          // );
        }

      }
    } catch (error) {
      console.log("contractLoadTemplateSaga error", error);
    }
  }
  );
  yield takeLatest([actionTypes.CONTRACT_SET_TEMPLATE, actionTypes.CONTRACT_REFRESH_DASHBOARD], function* loadDashboardAndMenuSaga() {
    try {
      let contractStore = yield select(getContract);
      let authStore = yield select(getAuth);
      const preferencesStore = yield select(getPreferences);

      //let langStore = yield select(getLang);

      if (contractStore.user && contractStore.contract && contractStore.template) {
        const apiCallPromises = [
          call(dashboardCrud.getContractDashboard, contractStore.contract.companyid, contractStore.contract.projectid, contractStore.contract.contractid),
          call(actionCrud.getContractPendingDrafts, contractStore.contract.contractid, contractStore.template.accessibleWfIds),
          call(actionCrud.getPendingActions, contractStore.contract.contractid, contractStore.template.accessibleWfIds)
        ]

        const dashboardItemResults = yield all(apiCallPromises);

        const { data: contractDashboard } = dashboardItemResults[0];
        const { data: rawPendingDrafts } = dashboardItemResults[1];
        let rawManualActions = dashboardItemResults[2].data;

        const ContractAsideMenu = MenuItemsHelper.getMainMenuItems(authStore.userProfile, preferencesStore.landingpage, contractStore.contract, contractStore.template, contractStore.user);
        const QuickActionsMenu = MenuItemsHelper.getContractQuickActionsMenuItems(contractStore.template);

        const manualActionsObj = MenuItemsHelper.getContractManualActions(rawManualActions, contractStore.template);
        const pendingDraftsObj = MenuItemsHelper.getContractPendingDrafts(rawPendingDrafts, contractStore.template);

        yield put(actions.setDashboardAndMenu(contractDashboard, manualActionsObj, ContractAsideMenu, QuickActionsMenu, contractStore.contract.currency, pendingDraftsObj));

      }
    } catch (error) {
      alert(error)
      console.log("loadDashboardAndMenuSaga error", error);
    }
  }
  );
  yield takeLatest([preferencesDuck.actionTypes.PREFERENCES_SET_LANDING_PAGE], function* contractRecalculateMenuItems() {
    try {
      const authStore = yield select(getAuth);
      let contractStore = yield select(getContract);
      if (!authStore || !authStore.userProfile || !authStore.authToken || !authStore.csrfToken || !authStore.authToken.token || !authStore.csrfToken.token) {
        return;
      }
      if (!contractStore.contract || !contractStore.template) {
        return;
      }
      const preferencesStore = yield select(getPreferences);
      const menuItems = MenuItemsHelper.getMainMenuItems(authStore.userProfile, preferencesStore.landingpage, contractStore.contract, contractStore.template, contractStore.user);
      yield put(actions.setMenuItems(menuItems));
    } catch (err) {
      console.log("error in contractRecalculateMenuItems", err);
    }
  }
  );

  yield takeLatest([actionTypes.CONTRACT_SET_DASHBOARD_AND_MENU, preferencesDuck.actionTypes.PREFERENCES_SET_PENDING_ACTION_FILTER], function* loadFilteredActionsSaga() {
    try {
      let contractStore = yield select(getContract);
      const preferencesStore = yield select(getPreferences);


      if (contractStore.user && contractStore.contract && contractStore.template) {
        let filteredManualActionsObj = {};


        if (preferencesStore.actionFilters) {
          const { showUpcoming, show7Days, showOverdue, showRecurring } = preferencesStore.actionFilters;

          let filteredActions = contractStore.manualActions.items.filter(action =>
            (showRecurring || (!action.recurring || action.RAGColor < 3)) &&  //action.duedate < addMonths(new Date(), 1)
            (showOverdue || action.RAGColor !== 1) &&
            (show7Days || action.RAGColor !== 2) &&
            (showUpcoming || action.RAGColor !== 3)
          );

          filteredManualActionsObj = MenuItemsHelper.getContractManualActions(filteredActions, contractStore.template);

        }


        yield put(actions.setFilteredActions(filteredManualActionsObj));

      }
    } catch (error) {
      alert(error)
      console.log("loadFilteredActionsSaga error", error);
    }
  }
  );
  yield takeLatest(actionTypes.CONTRACT_SET_CONTRACT, function* contractLoadUserSaga() {
    try {
      let contractStore = yield select(getContract);

      if (contractStore.contract) {
        const { data: contractUser } = yield userCrud.getContractUser(
          contractStore.contract.companyid,
          contractStore.contract.projectid,
          contractStore.contract.contractid
        );
        // const authStore = yield select(getAuth);
        yield put(actions.setUser(contractUser));
        SystemHelper.updateExternalTrackerLibraries();
      }
    } catch (err) {
      console.log("Error in contractLoadUserSaga:", err);
    }
  }
  );
  yield takeLatest([actionTypes.CONTRACT_LOAD_START, actionTypes.CONTRACT_REFRESH_USERS], function* contractLoadUsersSaga() {
    try {
      let contractStore = yield select(getContract);
      const { data: contractUsers } = yield contractUserCrud.getContractUsers(contractStore.contractid);
      yield put(actions.setUsers(contractUsers));
    } catch (err) {
      console.log("Error in contractLoadUsersSaga:", err);
    }
  }
  );

  yield takeLatest(actionTypes.CONTRACT_FETCH_ACTIVITIES, function* contractLoadActivitiesSaga() {
    try {
      let contractStore = yield select(getContract);
      if (contractStore.contract) {
        const { data: activities } = yield activityCrud.getContractActivities(
          contractStore.contract.companyid,
          contractStore.contract.projectid,
          contractStore.contract.contractid
        );
        yield put(actions.setActivities(JSON.parse(activities.aggregatelist)));
      }
    } catch (err) {
      console.log("Error in contractLoadActivitiesSaga:", err);
    }
  }
  );


}
